var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEaFeaturedListingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ea-featured-listing-icon_svg__a",
    d: "M0 0h50.847v50.847H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ea-featured-listing-icon_svg__c",
    d: "M0 60h63.05V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.203)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ea-featured-listing-icon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ea-featured-listing-icon_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.847 25.423c0 14.041-11.382 25.424-25.423 25.424C11.383 50.847 0 39.464 0 25.423 0 11.383 11.383 0 25.424 0c14.04 0 25.423 11.382 25.423 25.423",
    fill: "#F8D7CC",
    mask: "url(#ea-featured-listing-icon_svg__b)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ea-featured-listing-icon_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ea-featured-listing-icon_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    mask: "url(#ea-featured-listing-icon_svg__d)",
    d: "M38.644 58.983h11.187v-26.44H38.644z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.661 57.966h9.153V33.56H39.66v24.407zM37.627 60h13.22V31.525h-13.22V60z",
    fill: "#020303",
    mask: "url(#ea-featured-listing-icon_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E9EA",
    mask: "url(#ea-featured-listing-icon_svg__d)",
    d: "M8.136 58.983h11.186v-9.152H8.136z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.153 57.966h9.152v-7.119H9.153v7.12zM7.119 60h13.22V48.814H7.119V60z",
    fill: "#020303",
    mask: "url(#ea-featured-listing-icon_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E9EA",
    mask: "url(#ea-featured-listing-icon_svg__d)",
    d: "M23.39 58.983h11.186V43.73H23.39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.407 57.966h9.152v-13.22h-9.152v13.22zM22.373 60h13.22V42.712h-13.22V60z",
    fill: "#020303",
    mask: "url(#ea-featured-listing-icon_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020303",
    mask: "url(#ea-featured-listing-icon_svg__d)",
    d: "M0 60h63.05v-2.034H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E74A10",
    mask: "url(#ea-featured-listing-icon_svg__d)",
    d: "M50.847 8.135H39.202l2.877 2.876-15.031 15.032-7.91-7.91L2.598 34.67l5.732 5.776 10.089-10.09 7.91 7.91L47.83 16.764l3.016 3.016z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.034 34.675l4.299 4.33L18.419 28.92l7.91 7.91L47.83 15.327l2 1.997V9.152h-8.173l1.86 1.86-16.47 16.469-7.91-7.91L4.034 34.675zm4.293 7.213l-7.164-7.22 17.975-17.973 7.91 7.91L40.64 11.01l-3.894-3.893h15.117v15.117l-4.033-4.032-21.502 21.502-7.91-7.91L8.327 41.889z",
    fill: "#020303",
    mask: "url(#ea-featured-listing-icon_svg__d)"
  }))));
}
export default SvgEaFeaturedListingIcon;